<template>
  <div>
    <b-navbar
      toggleable="xl"
      style="min-height: 127px; background-color: #ec6c00"
    >
      <b-navbar-brand
        class=""
        @click="GoAction('MainPage')"
        style="cursor: pointer"
      >
        <img style="width: 150px" src="../../assets/logo.png" />
      </b-navbar-brand>
      <b-nav class="ml-auto phone_show">
        <b-nav-text right @click="Logout"
          ><b-button variant="danger">通知</b-button></b-nav-text
        >
        <b-nav-text right @click="Logout"
          ><b-button variant="light">登出</b-button></b-nav-text
        >
      </b-nav>
      <b-navbar-brand
        class="p1-2 phone_not_show_div"
        style="border-right: 6px solid white; height: 66px"
      >
      </b-navbar-brand>
      <b-nav class="ml-auto">
        <b-nav-text
          right
          disabled
          class="label_size"
          style="color: white !important; align-items: center; display: flex"
          >2024年05月25日 星期一 15:08:38 台北土城橘青春</b-nav-text
        >
        <b-nav-text class="ml-5 phone_not_show" right @click="Logout"
          ><b-button class="btn_customer" variant="danger"
            >通知</b-button
          ></b-nav-text
        >
        <b-nav-text class="ml-2 phone_not_show" right @click="Logout"
          ><b-button class="btn_customer" variant="light"
            >登出</b-button
          ></b-nav-text
        >
      </b-nav>
    </b-navbar>
  </div>
</template>
<script>
export default {
  props: ['GROUP_NAME'],
  data() {
    return {
      item_Array: [],
      //EMPNAME: this.$cookieFunc.getCookie('EMPNAME'),
      //CPNMC: this.$cookieFunc.getCookie('CPNMC'),
      EMPNAME: '',
      CPNMC: ''
    };
  },
  mounted() {
    //this.GetPERMISSIONS_BYID();
    this.init();
  },
  methods: {
    async init() {
      // var GROUP = await this.$Global.GetUserGroup(this.$cookieFunc.getCookie("PNM"), this.$cookieFunc.getCookie("PHONE"), 1, 10);
      // if (GROUP == "1") {
      //   this.Login_GROUP = "用戶";
      // }
      // else if (GROUP == "2") {
      //   this.Login_GROUP = "查看人員";
      // }
      // else if (GROUP == "3") {
      //   this.Login_GROUP = "主委/主任";
      // }
      // else if (GROUP == "4") {
      //   this.Login_GROUP = "工程人員";
      // }
      this.EMPNAME = this.$cookieFunc.getCookie('PNM');
    },
    Logout() {
      this.$cookieFunc.delCookie('PNM');
      this.$cookieFunc.delCookie('PHONE');
      this.$cookieFunc.delCookie('NAME');
      this.$cookieFunc.delCookie('RENT_NAME');
      this.$cookieFunc.delCookie('GROUP');
      this.$cookieFunc.delCookie('session');
      this.$router.push({
        name: 'Login'
      });
    },
    GoAction(page) {
      this.$router.push({
        name: page
      });
    },
    GoAction2(page) {
      this.$parent.b_items.splice(1);
      this.$parent.b_items.push({
        text: page.MENUNMC,
        to: { name: page.MENUNM }
      });
      this.$router.push({
        path: '/' + page.MENUNM
      });
    },
    GetPERMISSIONS_BYID() {
      var post_data = {
        EMPNO: this.$cookieFunc.getCookie('EMPNO')
      };
      this.$axios({
        method: 'post',
        url: this.$URLJson.GetPERMISSIONS_BYID,
        data: post_data
      })
        .then((res) => {
          var data = res.data;
          for (var i in data) {
            if (this.SYS == data[i].SYS) {
              if (data[i].IDX == '0') {
                var temp = {
                  MENUNM: data[i].MENUNM,
                  MENUNMC: data[i].MENUNMC,
                  GROUPNO: data[i].GROUPNO,
                  children: []
                };
                this.item_Array.push(temp);
              } else {
                var temp2 = {
                  MENUNM: data[i].MENUNM,
                  MENUNMC: data[i].MENUNMC,
                  GROUPNO: data[i].GROUPNO,
                  READCD: data[i].READCD,
                  EDITCD: data[i].EDITCD
                };
                var idx = this.item_Array.findIndex(function (o) {
                  return o.GROUPNO == data[i].GROUPNO;
                });
                this.item_Array[idx].children.push(temp2);
              }
            }
          }
        })
        .catch(function (error) {
          // 請求失敗處理
          console.log(error);
        });
    }
  }
};
</script>
<style scoped>
@media (max-width: 1120px) {
  .phone_not_show_div {
    display: none;
  }
}

@media (min-width: 935px) {
  .phone_not_show {
    display: flex;
  }

  .phone_show {
    display: none;
  }
}

@media (max-width: 934px) {
  .phone_not_show {
    display: none;
  }

  .phone_show {
    display: flex;
  }
}

@media (max-width: 654px) {
  .label_size {
    font-size: 1.25rem;
  }
}

@media (max-width: 475px) {
  .label_size {
    font-size: 0.75rem;
  }
}

@media (min-width: 655px) {
  .label_size {
    font-size: 2.3rem;
  }
}

.btn_customer {
  padding: 0.5rem 1rem;
  font-size: 1.5rem;
  line-height: 1.5;
  border-radius: 0.65rem;
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/MyModule/NavHeader.vue